import { DateTimeLocalizationInfo, DateTimeService, DateTimeUtils } from '@mews/framework';
import { BookablePeriod } from '@mews-commander/data-access';
import { getTimeUnitsCounts } from '../../dates/ReservationDatesPicker/utils';
import { unitCounter } from '../../../utils/dates';
import { dateAndTimeToUtc } from './dateTime';

export const getBookablePeriodsDiffs = (
    arrivalDate: string,
    departureDate: string,
    arrivalHours: string,
    departureHours: string,
    timezone: string,
    localizationInfo: DateTimeLocalizationInfo,
    isDayUse: boolean
): Record<BookablePeriod, number> => {
    const startUtc = dateAndTimeToUtc(arrivalDate, arrivalHours, localizationInfo, timezone);
    const endUtc = dateAndTimeToUtc(departureDate, departureHours, localizationInfo, timezone);
    if (!startUtc || !endUtc) {
        return {
            [BookablePeriod.Day]: 0,
            [BookablePeriod.Night]: 0,
            [BookablePeriod.Month]: 0,
            [BookablePeriod.Hour]: 0,
        };
    }

    const start = DateTimeService.fromUtcString(startUtc.value, timezone);
    const end = DateTimeService.fromUtcString(endUtc.value, timezone);

    const { monthCount, nightCount } = getTimeUnitsCounts({
        startDate: DateTimeUtils.utcToStructuredDate(startUtc.value, timezone),
        endDate: DateTimeUtils.utcToStructuredDate(endUtc.value, timezone),
    });
    const daysCount = unitCounter({ isDayService: isDayUse, nightCount });

    return {
        [BookablePeriod.Day]: daysCount,
        [BookablePeriod.Night]: nightCount,
        [BookablePeriod.Month]: monthCount,
        [BookablePeriod.Hour]: DateTimeService.diffHours(end, start),
    };
};
